import { render, staticRenderFns } from "./InternetChangeRoomId.vue?vue&type=template&id=466c7ea6"
import script from "./InternetChangeRoomId.vue?vue&type=script&lang=js"
export * from "./InternetChangeRoomId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports